import React from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../../Icons/CloseIcon';

// import CancelIcon from '../../Icons/CancelIcon';

interface TableFilterBoxContentWrapperProps {
  children: React.ReactNode;
  setShowDropDown?: (...args: any) => void;
}

const TableFilterBoxContentWrapper: React.FC<
  TableFilterBoxContentWrapperProps
> = ({ children, setShowDropDown }) => {
  const onClickCancel = (e: any) => {
    setShowDropDown && setShowDropDown(false);
  };

  return (
    <Container
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HeaderArea>
        <Header>Filter By</Header>
        <IconContainer onClick={onClickCancel}>
          <CloseIcon />
        </IconContainer>
      </HeaderArea>
      {children}
    </Container>
  );
};

export default TableFilterBoxContentWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  /* border-radius: 5px; */
  background-color: white;
  width: 325px;
  /* box-shadow: 0 4px 28px 0 rgba(0, 0, 0, 0.08); */
  gap: 20px;
  height: fit-content;

  @media (max-width: 884px) {
    /* border: 2px solid green; */
    width: 100%;
    height: fit-content;
    margin-right: 25px;
    margin-left: 25px;
    margin-top: 132px;
    width: 500px;
    padding: 32px;
  }

  @media (max-width: 480px) {
    width: 90%;
    padding: 24px;
  }
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19.2px;
`;

const IconContainer = styled.div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: grid;
  place-content: center;

  transform: scale(100%);
  transition: transform 0.3s ease-out;

  &:hover {
    transform: scale(110%);
  }
`;
